const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[+-][\d\s().-]*$/;

export const toUtcIso = (value) => (value ? new Date(value).toISOString() : '');

const escapeCell = (value) => {
    let text = value === null || value === undefined ? '' : String(value);
    if (FORMULA_START.test(text) && !PLAIN_NUMBER.test(text)) text = `'${text}`;
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const downloadCsv = (baseName, headers, rows) => {
    const csv = [headers, ...rows].map((row) => row.map(escapeCell).join(',')).join('\r\n');
    const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${baseName}-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
